import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { jobEndpoints } from '@/lib/api/endpoints';
import { jobKeys } from '@/lib/queryKeys';
import type { JobUpcomingVisit } from '@/types/job';

/**
 * GAP-03 — the recurring job's projected, not-yet-materialised visits (the
 * generator expands the RRULE honouring season/holiday/blackout + tz). Only
 * fetched for RECURRING jobs; one-off jobs return [] anyway, so we skip the call.
 */
export function useJobUpcomingVisits(jobId: string, isRecurring: boolean) {
  return useApiQuery<JobUpcomingVisit[]>({
    queryKey: jobKeys.upcomingVisits(jobId),
    queryFn: () => apiGet<JobUpcomingVisit[]>(operationsClient, jobEndpoints.upcomingVisits(jobId)),
    enabled: Boolean(jobId) && isRecurring,
  });
}
